<div class="sidesheet mat-elevation-z2">
    <nivelaciones-convenciones [direccion]="'vertical'" [completo]="'false'" [asistencia]="'true'"></nivelaciones-convenciones>
</div>
<div style="width: calc(100% - 48px); margin: 48px auto; padding-right: 332px; padding-left: 15px;">
    <h4 class="mat-h2">Nivelaciones por alumno y materia</h4>
    <nav-bar [navBarItems]="periodosNavBar" [initialValue]="+periodosNavBar[0].value" [placeholder]="'Seleccione un año'"
        [navOnChange]="true"></nav-bar>
    <div class="nivelaciones-directorCurso-container">
        <div class="grid-header">
            <div class="spacer"></div>
        </div>
        <div class="table-container">
            <mat-table #table [dataSource]="dataSource" matSort [ngStyle]="{'width': tableWidth + 'px'}">
                <ng-container *ngFor="let col of displayedColumns">
                    <ng-container *ngIf="col === 'Alumno'">
                        <ng-container matColumnDef="{{col}}">
                            <mat-header-cell *matHeaderCellDef mat-sort-header class="nombres-col"> {{col}}</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="nombres-col">
                                {{element.alumno.apellidosNombres}}
                            </mat-cell>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="col != 'Alumno'">
                        <ng-container matColumnDef="{{col}}">
                            <mat-header-cell *matHeaderCellDef mat-sort-header class="materias-col"> {{col}}</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="materias-col col-cont">
                                <small class="nota-acumulada" matTooltip="Nota acumulada" matTooltipPosition="above">{{(element.materiasNivelacion
                                    | materiaFilter:
                                    col).notasAcumuladas.notaAcumulada}}</small>
                                <div class="flex-wrap container-de-bolitas-container">
                                    <div class="bolitas-container">
                                        <ng-container *ngIf="(element.materiasNivelacion | materiaFilter: col).ausentes !== 0">
                                            <div class="detalle mat-elevation-z8"
                                                #detallesAusente hidden>
                                                <button mat-icon-button class="md-14">
                                                    <mat-icon class="md-14">close</mat-icon>
                                                </button>
                                                <ul class="detalle-lista">
                                                    <li *ngFor="let detalleAusentes of (element.materiasNivelacion | materiaFilter: col).ausentesDetalle"
                                                        class="detalle-item">
                                                        <mat-icon class="md-14">calendar_today</mat-icon>
                                                        {{detalleAusentes.fechaCorta}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <span class="circulo error cursor-pointer" (click)="toggleDetalles(detallesAusente, $event)">
                                                {{(element.materiasNivelacion | materiaFilter: col).ausentes}}
                                            </span>
                                        </ng-container>
                                    </div>
                                    <div class="bolitas-container">
                                        <ng-container *ngIf="(element.materiasNivelacion | materiaFilter: col).retardos !== 0">
                                            <div class="detalle mat-elevation-z8"
                                                #detallesRetardo hidden>
                                                <button mat-icon-button class="md-14">
                                                    <mat-icon class="md-14">close</mat-icon>
                                                </button>
                                                <ul class="detalle-lista">
                                                    <li *ngFor="let detalleRetardos of (element.materiasNivelacion | materiaFilter: col).retardosDetalle"
                                                        class="detalle-item">
                                                        <mat-icon class="md-14">calendar_today</mat-icon>
                                                        {{detalleRetardos.fechaCorta}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <span class="circulo warn cursor-pointer" (click)="toggleDetalles(detallesRetardo, $event)">
                                                {{(element.materiasNivelacion | materiaFilter: col).retardos}}
                                            </span>
                                        </ng-container>
                                    </div>
                                    <div class="bolitas-container">
                                        <ng-container *ngIf="(element.materiasNivelacion | materiaFilter: col).presentes !== 0">
                                            <div class="detalle mat-elevation-z8"
                                                #detallesPresente hidden>
                                                <button mat-icon-button class="md-14">
                                                    <mat-icon class="md-14">close</mat-icon>
                                                </button>
                                                <ul class="detalle-lista">
                                                    <li *ngFor="let detallePresentes of (element.materiasNivelacion | materiaFilter: col).presentesDetalle"
                                                        class="detalle-item">
                                                        <mat-icon class="md-14">calendar_today</mat-icon>
                                                        {{detallePresentes.fechaCorta}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <span class="circulo success cursor-pointer" (click)="toggleDetalles(detallesPresente, $event)">
                                                {{(element.materiasNivelacion | materiaFilter: col).presentes}}
                                            </span>
                                        </ng-container>
                                    </div>
                                    <div class="bolitas-container">
                                        <ng-container *ngIf="(element.materiasNivelacion | materiaFilter: col).noReportaAsistencia !== 0">
                                            <div class="detalle mat-elevation-z8"
                                                #detallesNoReporta hidden>
                                                <button mat-icon-button class="md-14">
                                                    <mat-icon class="md-14">close</mat-icon>
                                                </button>
                                                <ul class="detalle-lista">
                                                    <li *ngFor="let detalleNoReporta of (element.materiasNivelacion | materiaFilter: col).noReportaAsistenciaDetalle"
                                                        class="detalle-item">
                                                        <mat-icon class="md-14">calendar_today</mat-icon>
                                                        {{detalleNoReporta.fechaCorta}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <span class="circulo neutral cursor-pointer" (click)="toggleDetalles(detallesNoReporta, $event)">
                                                {{(element.materiasNivelacion | materiaFilter:
                                                col).noReportaAsistencia}}
                                            </span>
                                        </ng-container>
                                    </div>
                                    <div class="bolitas-container">
                                        <ng-container *ngIf="(element.materiasNivelacion | materiaFilter: col).futuras !== 0">
                                            <div class="detalle mat-elevation-z8"
                                                #detallesFuturas hidden>
                                                <button mat-icon-button class="md-14">
                                                    <mat-icon class="md-14">close</mat-icon>
                                                </button>
                                                <ul class="detalle-lista">
                                                    <li *ngFor="let detalleFuturas of (element.materiasNivelacion | materiaFilter: col).futurasDetalle"
                                                        class="detalle-item">
                                                        <mat-icon class="md-14">calendar_today</mat-icon>
                                                        {{detalleFuturas.fechaCorta}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <span class="circulo cursor-pointer" (click)="toggleDetalles(detallesFuturas, $event)">
                                                {{(element.materiasNivelacion | materiaFilter: col).futuras}}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </mat-cell>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;">
                </mat-row>
            </mat-table>
        </div>
    </div>
</div>
